import { render, staticRenderFns } from "./PlaceOfWork.vue?vue&type=template&id=64bccfa6"
import script from "./PlaceOfWork.vue?vue&type=script&lang=js"
export * from "./PlaceOfWork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports